<template>
  <div class="account__profile u-bg-grey u-full-width u-pad-x-lg u-pad-b-md u-pad-md--sm" :class="{'account__profile--full' : isFull}">
    <h1 class="u-white">{{$t('account.profile')}}</h1>
    <div class="u-flex u-column u-marg-l-1of8 u-marg-r-1of8 account__profile--nomarge">
      <label for="firstName">{{$t('account.name')}}</label>
      <input
        v-model="fields.firstName"
        type="text"
        id="firstName"
        class="t-input u-w8of8"
      />
      <label for="lastName">{{$t('account.surname')}}</label>
      <input
        v-model="fields.lastName"
        type="text"
        id="lastName"
        class="t-input u-w8of8"
      />
      <label for="company">{{$t('account.company')}}</label>
      <input
        v-model="fields.company"
        type="text"
        id="company"
        class="t-input u-w8of8"
      />
      <label for="role">{{$t('account.role')}}</label>
      <input
        v-model="fields.role"
        type="text"
        id="role"
        class="t-input u-w8of8"
      />
      <label for="role">{{$t('account.email')}}</label>
      <input
        v-model="email"
        type="text"
        id="role"
        disabled
        class="t-input u-w8of8 u-grey"
      />
    </div>
    <!-- <p class="account__profile--txt u-grey-light t-h2 u-left u-marg-l-1of8 u-marg-b-xs u-marg-b-md--sm account__profile--nomarge">{{$t('account.yourPicture')}}</p>
    <div class="u-row u-middle u-marg-l-1of8 u-marg-r-1of8 u-between account__profile--nomarge">
      <div class="account__profile--picture u-w2of8 u-bg-grey u-box-1by1">
        <img :src="picture" alt="Profile picture" class="u-wrapper-panel u-fit-cover">
      </div>
      <div class="t-input-file u-w5of8">
        <input
          accept="image/png, image/jpeg"
          class="t-input-file__input"
          @change="onSelectFile"
          type="file"
          name="upload"
          id="file-uploader"
        >
        <label for="file-uploader" class="t-h2 u-orange u-block u-relative u-flex u-center u-middle u-cursor-pointer u-bg-grey">
          <img src="/images/file.png" alt="icon picture" class="t-text--small"/>
          {{$t('account.picture')}}
        </label>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    isFull: {
      type: Boolean,
      default: false
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    // picture: {
    //   type: String,
    //   default: ''
    // }
  },
  data () {
    return {
      fields: {
        firstName: '',
        lastName: '',
        company: '',
        role: ''
      }
    }
  },
  created () {
    this.applyFields()
  },

  methods: {
    applyFields () {      
      this.fields.firstName = this.firstName
      this.fields.lastName = this.lastName
      this.fields.company = this.company
      this.fields.role = this.role
    },
    async onSelectFile (event) {
      const file = event.target.files[0]
      const buffer = await file.arrayBuffer()
      this.$store.dispatch('user/profilePicture', {
        type: file.type,
        name: file.name,
        data: buffer
      })
    }
  },

  watch: {
    firstName () {
      this.applyFields()
    },
    lastName () {
      this.applyFields()
    },
    company () {
      this.applyFields()
    },
    role () {
      this.applyFields()
    },
    fields: {
      deep: true,
      handler () {
        this.$emit('change', this.fields)
      }
    }
  }
}
</script>

<style lang="stylus">
.account__profile
    //padding 20px 40px 40px 40px
    border-radius 20px
    // max-width 550px
    // min-width 500px
    &--full
      padding 25px
      width 100%
      min-width inherit
    &--nomarge
      margin-left 0
      margin-right 0
      .t-input
        padding 10px 30px
    &--txt
      margin-top 40px
    &--picture 
      border-radius 100px
      height 70px
      width 70px
      overflow hidden
</style>